(function () {
  var CART_FINISHED = 'onCartFinished';

  function groupRoot(el) {
    return el && el.closest('[data-cart-group-keys]');
  }

  function keysFrom(el) {
    var raw = el && el.getAttribute('data-cart-group-keys');
    if (!raw) return [];
    return raw.split(',').map(function (k) { return k.trim(); }).filter(Boolean);
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) { return res.json(); });
  }

  function refreshCart() {
    window.dispatchEvent(new CustomEvent(CART_FINISHED, { bubbles: true }));
  }

  function updateLines(updates) {
    return postJson('/cart/update.js', { updates: updates }).then(refreshCart);
  }

  function changeLine(payload) {
    return postJson('/cart/change.js', payload);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-remove-group-keys]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var keys = link.getAttribute('data-remove-group-keys').split(',').map(function (k) {
      return k.trim();
    }).filter(Boolean);
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    updateLines(updates);
  }, true);

  document.addEventListener('onQtyChange', function (event) {
    var selector = event.detail && event.detail.qtySelector;
    if (!selector) return;
    var root = groupRoot(selector);
    if (!root) return;
    var keys = keysFrom(root);
    if (!keys.length) return;
    var nextTotal = Number(event.detail.newValue);
    if (isNaN(nextTotal) || nextTotal < 0) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(function (item) { return keys.indexOf(item.key) !== -1; });
        var currentTotal = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        var delta = nextTotal - currentTotal;
        var updates = {};

        if (nextTotal === 0) {
          keys.forEach(function (key) { updates[key] = 0; });
          return updateLines(updates);
        }

        if (delta > 0) {
          var first = lines[0];
          if (!first) return;
          updates[first.key] = first.quantity + delta;
          return updateLines(updates);
        }

        if (delta < 0) {
          var remaining = -delta;
          for (var i = lines.length - 1; i >= 0 && remaining > 0; i -= 1) {
            var take = Math.min(lines[i].quantity, remaining);
            updates[lines[i].key] = lines[i].quantity - take;
            remaining -= take;
          }
          return updateLines(updates);
        }
      })
      .catch(function () {});
  });

  function lineGroupId(line, fallback) {
    var props = (line && line.properties) || {};
    if (props._cart_group) return String(props._cart_group);
    if (line && line.selling_plan_allocation) return 'sub';
    return fallback || 'otp';
  }

  function lineProperties(line, groupId) {
    var props = {};
    var source = (line && line.properties) || {};
    Object.keys(source).forEach(function (key) {
      if (source[key] != null && typeof source[key] !== 'object') {
        props[key] = source[key];
      }
    });
    props._cart_group = groupId;
    return props;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    var isCheckbox = target.matches && target.matches('[data-cart-product-recharge-checkbox]');
    var isSelect = target.matches && target.matches('[data-cart-product-recharge-select]');
    if (!isCheckbox && !isSelect) return;

    var root = target.closest('[data-cart-product]');
    if (!root) return;

    event.stopImmediatePropagation();

    var groupedRoot = groupRoot(target);
    var keys = groupedRoot ? keysFrom(groupedRoot) : [];
    if (!keys.length) {
      var singleKey = root.getAttribute('data-key');
      if (singleKey) keys = [singleKey];
    }
    if (!keys.length) return;

    var fallbackGroupId = root.getAttribute('data-cart-group-id') || 'otp';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var planId = null;
        if (isCheckbox) {
          if (target.checked) {
            planId = parseInt(root.getAttribute('data-default-subscription-id'), 10) || null;
          }
        } else {
          planId = parseInt(target.value, 10) || null;
        }

        var chain = Promise.resolve();
        keys.forEach(function (key) {
          var line = cart.items.find(function (item) { return item.key === key; });
          if (!line) return;
          var groupId = lineGroupId(line, fallbackGroupId);
          chain = chain.then(function () {
            return changeLine({
              id: key,
              quantity: line.quantity,
              selling_plan: planId,
              properties: lineProperties(line, groupId)
            });
          });
        });
        return chain.then(refreshCart);
      })
      .catch(function () {});
  }, true);
})();
